export default "__VITE_ASSET__BDxxOQbK__"